import { render, staticRenderFns } from "./FormItemList.vue?vue&type=template&id=b037a60e&scoped=true"
import script from "./FormItemList.vue?vue&type=script&lang=js"
export * from "./FormItemList.vue?vue&type=script&lang=js"
import style0 from "./FormItemList.vue?vue&type=style&index=0&id=b037a60e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b037a60e",
  null
  
)

export default component.exports